export default __webpack_public_path__ + "assets/img/redeem-access_enter-code@2x.png";